import React from 'react';
import {useField} from 'formik';

import TestDate from '../test-date';
import Scores from '../scores';

const PsatForm = () => {
  const [field] = useField('type');

  return (
    <>
      <TestDate />
      {field.value === 'psat' ? (
        <Scores min={20} max={80} step={1} />
      ) : (
        <Scores min={160} max={760} step={10} />
      )}
    </>
  );
};

export default PsatForm;
